import React from "react";
import { Route } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import SiteLayout from "../site/SiteLayout";
import { lazyPage } from "../lib/lazyPage";
const LandingPage = lazyPage(() => import("./pages/LandingPage"));
const ResultsPage = lazyPage(() => import("./pages/ResultsPage"));
const PrivacyPolicyPage = lazyPage(() => import("./pages/PrivacyPolicyPage"));
const TermsOfServicePage = lazyPage(() => import("./pages/TermsOfServicePage"));
const UnsubscribePage = lazyPage(() => import("./pages/UnsubscribePage"));
import "./pr.css";

const B = "/payment-relief";

function Wrap({ children }) {
  return (<><Helmet><link href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700&family=Inter:wght@400;500;600;700&display=swap" rel="stylesheet" /></Helmet><SiteLayout outside={<div className="pr" data-testid="pr-root">{children}</div>} /></>);
}

// Spread inside <Routes>: {prRoutes()}
export function prRoutes() {
  const pages = [["/", LandingPage], ["/results/:id", ResultsPage], ["/privacy-policy", PrivacyPolicyPage], ["/terms-of-service", TermsOfServicePage], ["/unsubscribe", UnsubscribePage]];
  return pages.flatMap(([p, C]) => [B + p, B + p + "/"].filter((x, i, a) => a.indexOf(x) === i).map((path) => <Route key={path} path={path} element={<Wrap><C /></Wrap>} />));
}
